import { Children, cloneElement, isValidElement, type ReactNode } from 'react'

import '@app/components/virtual-page.scss'

export const VirtualPage = ({ index, pageIndex, isActive, children }: { index: number; pageIndex?: number; isActive?: boolean; children: ReactNode }) => {
  const childrenToRender = Children.toArray(children)
  const resolvedIndex = childrenToRender.length === 1 ? 0 : Math.min(index, childrenToRender.length)
  const className = `virtual-page virtual-page--${pageIndex ?? resolvedIndex} ${isActive ? 'virtual-page--active' : ''}`
  const pageToRender = childrenToRender.length > 0 ? childrenToRender[resolvedIndex] : children

  // console.log('Rendering VirtualPage', { index, pageIndex, 'childrenCount': childrenToRender.length, isActive, resolvedIndex, className })

  const cloned = pageToRender && [pageToRender].map((child) =>
    isValidElement(child) ? cloneElement(child, { isActive } as Record<string, unknown>) : child
  )

  return <div className={className}>{cloned}</div>
}
